module.exports = __webpack_public_path__ + "media/promo/hochland/images/snow3-f275d34662ce9a866a75359d11319ce9.png";